import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { DomainResult } from '../../types/index';
import MobilitySummaryDisplay from './summary/MobilitySummaryDisplay';

interface MobilityAssessmentDetailProps {
  assessmentData?: DomainResult;
}

const MobilityAssessmentDetail: React.FC<MobilityAssessmentDetailProps> = ({ assessmentData }) => {
  const navigate = useNavigate();

  if (!assessmentData) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">未找到评估数据</h2>
          <button
            onClick={() => navigate('/results')}
            className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors"
          >
            返回结果页面
          </button>
        </div>
      </div>
    );
  }


  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white border-b border-gray-200 px-4 py-4">
        <div className="max-w-4xl mx-auto flex items-center">
          <button
            onClick={() => navigate('/results')}
            className="flex items-center text-gray-600 hover:text-gray-800 transition-colors mr-4"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            返回结果页面
          </button>
          <h1 className="text-2xl font-bold text-gray-800">行动能力评估详情</h1>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 py-8">
        <MobilitySummaryDisplay 
          assessmentData={assessmentData}
          className="bg-white rounded-lg shadow-sm border border-gray-200 p-6"
        />
      </div>
    </div>
  );
};

export default MobilityAssessmentDetail;